import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const cancelScrollForScreens = ["/history/"];

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const shouldCancelScroll = cancelScrollForScreens.some(
      cancelScrollForScreen => pathname.includes(cancelScrollForScreen),
    );
    if (!shouldCancelScroll) window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
